module.exports = __webpack_public_path__ + "img/customer_tag_1.b40ed9ea.png";